import Utils from "./Utils";
import EventEmitter from "./EventEmitter";
export default class Playback extends EventEmitter {
  constructor(data = "json/recordings.json") {
    super();
    console.log("*data*", data);
    this.data = data;
  }

  load() {
    this.init();
  }

  async init() {
    this.sequence = null;
    if (typeof this.data === "string") {
      this.sequence = await Utils.loadJSON(this.data);
      console.log("*** NEW SEQUENCE ***");
    } else {
      // in case if object is passed
      this.sequence = this.data;
    }

    if (this.ADD_WHITE_SPACE) {
      for (let i = 0; i < 3; i++) {
        this.sequence.timings.unshift(100);
        this.sequence.actions.unshift("+");
        this.sequence.letters.unshift(" ");
      }
    }
    this.emit("ready", []);
  }

  start() {
    if (this.sequence) {
      const time = this.sequence.timings.shift();
      const action = this.sequence.actions.shift();
      const letter = this.sequence.letters.shift();
      this.timeout_data = {
        timing: time,
        action: action,
        letter: letter,
      };
      this.TIMEOUT = setTimeout(() => {
        // console.log(action, letter);
        this.emit("play", [[action, letter]]);
        if (this.sequence.timings.length > 0) this.start();
        else this.emit("complete", []);
      }, time);
    } else {
      // throw error
      console.error("No timing data to play back");
    }
  }

  // GAME PLAYBACK WITH DEFAUT TIMINGS
  launchHiddenWordSequence(word, clue = 0) {
    // this.emit("play", [["launch", word]]);
    const defaultTiming = 300;
    const defaultAction = "+";
    const defaultLetter = word.shift();

    console.log(defaultLetter);
    this.TIMEOUT = setTimeout(() => {
      // console.log(action, letter);
      this.emit("playGameSetupSequence", [
        [defaultAction, defaultLetter, clue],
      ]);
      if (word.length > 0) this.launchHiddenWordSequence(word, clue);
      else this.emit("gameSetupIsComplete", []);
    }, defaultTiming);
  }

  pause() {
    clearTimeout(this.TIMEOUT);
    this.sequence.letters.unshift(this.timeout_data.letter);
    this.sequence.timings.unshift(this.timeout_data.timing);
    this.sequence.actions.unshift(this.timeout_data.action);
    this.emit("pause", []);
  }

  // option to skip sequence quickly
  skip() {
    clearTimeout(this.TIMEOUT);
    this.sequence.letters.unshift(this.timeout_data.letter);
    this.sequence.timings.unshift(this.timeout_data.timing);
    this.sequence.actions.unshift(this.timeout_data.action);

    this.resumeQuickly();
  }

  resumeQuickly() {
    if (this.sequence) {
      const time = this.sequence.timings.shift();
      const action = this.sequence.actions.shift();
      const letter = this.sequence.letters.shift();
      this.timeout_data = {
        timing: time,
        action: action,
        letter: letter,
      };
      this.TIMEOUT = setTimeout(() => {
        // console.log(action, letter);
        this.emit("play", [[action, letter]]);
        if (this.sequence.timings.length > 0) this.resumeQuickly();
        else this.emit("complete", []);
      }, 10);
    } else {
      // throw error
      console.error("No timing data to play back");
    }
  }
}
